function init() {
    const floatContainers = document.querySelectorAll('.FormTextbox');

    if (floatContainers !== null && floatContainers !== undefined) {
        floatContainers.forEach(function (float) {

            let floatInput = float.querySelector('.FormTextbox__Input');

            float.addEventListener('click', function () {
                this.classList.add('active');
            });

            floatInput.addEventListener('blur', function (e) {
                if (!floatInput.value) {
                    e.target.parentNode.classList.remove('active');
                }
            });
        });
    }

    const inputFocus = document.querySelectorAll('.FormTextbox__Input');

    if (inputFocus !== null && inputFocus !== undefined) {
        inputFocus.forEach(function (inputs) {

            inputs.addEventListener('focus', function (e) {
                e.target.parentNode.classList.add('active');
            });

            if (inputs.value.length !== 0) {
                inputs.parentNode.classList.add('active');
            }

        });
    }

    const selectOption = document.querySelectorAll('select');
    // Change color of select value
    if (selectOption !== null && selectOption !== undefined) {

        selectOption.forEach(function (select) {
            select.addEventListener('change', function () {
                this.style.color = '#333333';
            });
        });
    }
}
const formSelectContainer = document.getElementById("interests");

if (formSelectContainer !== null && formSelectContainer !== undefined) {
    formSelectContainer.addEventListener("change", (event) => {
        var targetId = event.target.value;

        var routeUrl = window.location.href.substr(0, window.location.href.indexOf('?'));
        var params = "?formId=" + targetId;
        $.ajax({
            url: routeUrl + params,
            type: 'GET',

            success: function (result) {
                window.history.replaceState(null, null, params == "" ? "?" : params);
                $("#formItem").replaceWith($(result).find('#formItem'));
                init();
            }, error: function (e) {
                console.log("error: ", e);
            }
        });
    });
}